var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 16"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "play_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1112 0v251H0V0h1112Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "play_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.96 0c.389 0 .77.11 1.093.314l8.41 5.32c1.387.878 1.754 2.647.82 3.951a2.944 2.944 0 0 1-.819.771l-8.41 5.33c-.897.568-2.115.345-2.72-.498A1.765 1.765 0 0 1 0 14.158V1.842C0 .825.877 0 1.96 0Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#play_svg__a)",
    transform: "translate(-78 -106)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#play_svg__b)",
    transform: "translate(78 106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h12.8v16H0V0z"
  })))));
};

export default SvgPlay;